import React from 'react'
import { connect } from 'react-redux'

import { createExperience, updateExperience, deleteExperience } from 'actions'
import { experienceSelector } from 'selectors'

import {
  Form,
  Field,
  Label,
  DescriptionInput,
  Input,
} from 'components/form'
import Button from 'components/Button'
import ButtonGroup from 'components/ButtonGroup'

import EditEducation from './EditEducation'
import EditHobby from './EditHobby'
import EditWork from './EditWork'
import EditEmployment from './EditEmployment'

const formTypes = {
  education: EditEducation,
  hobby: EditHobby,
  work: EditWork,
  employment: EditEmployment,
}

class EditExperience extends React.Component {
  state = {
    type: this.props.type || 'work',
    duration: this.props.duration || '',
    tags: this.props.tags || [],
    description: this.props.description || '',
    customer: this.props.customer || '',
    employer: this.props.employer || '',
    roles: this.props.roles || [],
    name: this.props.name || '',
    degree: this.props.degree || '',
    university: this.props.university || '',
  }

  submit = e => {
    e.preventDefault()
    this.props.experienceId
      ? this.props.updateExperience(
          this.props.consultantId,
          this.props.experienceId,
          {
            ...this.state,
          }
        )
      : this.props.createExperience(this.props.consultantId, {
          ...this.state,
        })

    this.props.closeModal()
  }

  deleteExperience = e => {
    e.preventDefault()
    this.props.deleteExperience(
      this.props.consultantId,
      this.props.experienceId
    )

    this.props.closeModal()
  }

  editForm = () => {
    const EditForm = formTypes[this.state.type]
    return (
      <EditForm
        {...this.state}
        onChange={({ key, value }) => this.setState({ [key]: value })}
        style={{ width: '100%' }}
      />
    )
  }

  render() {
    return (
      <Form onSubmit={this.submit}>
        {/*<Field>
          <Label htmlFor="type">Type erfaring</Label>
          <Select
            options={{
              work: 'Prosjekt for kunde',
              employment: 'Fast ansettelse',
              education: 'Utdannelse',
              hobby: 'Prosjekt på fritiden',
            }}
            value={this.state.type}
            onChange={type => this.setState({ type })}
          />
          </Field>*/}
        {this.editForm()}
        <Field>
          <Label htmlFor="duration">Ca lengde på jobben?</Label>
          <Input
            type="text"
            id="duration"
            placeholder="F.eks. 3 uker"
            value={this.state.duration}
            onChange={e => this.setState({ duration: e.target.value })}
          />
        </Field>
        <Field>
          <Label htmlFor="description">Hva gjorde du</Label>
          <DescriptionInput
            id="description"
            value={this.state.description}
            onChange={e => this.setState({ description: e.target.value })}
          />
        </Field>
        {/*<Field>
          <Label id="tags">Tags</Label>
          <TagsInput
            id="tags"
            value={this.state.tags}
            onChange={tags => this.setState({ tags })}
          />
        </Field>*/}
        <ButtonGroup>
          <Button type="submit">Lagre</Button>
          {this.props.experienceId && (
            <Button secondary type="button" onClick={this.deleteExperience}>
              Slett
            </Button>
          )}
        </ButtonGroup>
      </Form>
    )
  }
}

const mapStateToProps = (state, { consultantId, experienceId }) => ({
  consultantId,
  experienceId,
  ...(experienceSelector(state, consultantId, experienceId) || {}),
})

const mapDispatchToProps = {
  createExperience,
  updateExperience,
  deleteExperience,
}

export default connect(mapStateToProps, mapDispatchToProps)(EditExperience)



// WEBPACK FOOTER //
// ./src/components/EditExperience/index.js